import type { ReactNode } from 'react'
import React from 'react'

import { Box } from '@gousto-internal/citrus-react'

type ContentWrapperProps = {
  children: ReactNode
}

export const ContentWrapper = ({ children }: ContentWrapperProps) => (
  <Box paddingH={3} paddingV={3} width="100%">
    {children}
  </Box>
)
